import { getDshProblemList } from '@/api/api_prepareProblemList'

const state = {
  dshProblemData: []
}

const mutations = {
  SET_DSH_PROBLEM_DATA: (state, data) => {
    state.dshProblemData = data
  }
}

const actions = {
  actions_getDshProblemList ({ commit }) {
    return new Promise((resolve, reject) => {
      getDshProblemList().then(response => {
        const data = response.data
        if (data.isOk) {
          commit('SET_DSH_PROBLEM_DATA', data.data)
          resolve()
        } else {
          reject(data.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}

const getters = {
  dshProblemList: state => state.dshProblemData
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/prepareProblemListData.js